import { QueryClient } from "@tanstack/react-query";

/**
 * Module-scope query client so non-React code paths (the LootClient's
 * onSessionExpired callback and the imperative session mint in queries.ts)
 * share the same cache as the hooks.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
